import { atom } from 'recoil';

export const ArchImgUrl = atom({
    key: 'RI003-ArchImgUrl',
    default: undefined,
});

export const isExpandArchDiagram = atom({
    key: 'RI003-isExpandArchDiagram',
    default: false,
});

export const OrderPayload = atom({
    key: 'RI003-OrderPayload',
    default: {
        catalogCode: null,
        projectId: null,
        projectDetails: null,
        businessUnit: null,
        sector: null,
        program: null,
        division: null,
        environment: null,
        dataClassification: null,
        budgetCode: null,
        budgetCodeDetails: null,
        billingInfo: null,
        nonPrivilegedADGroupList: [{ readerValue: '' }],
        privilegedADGroupList: [{ contributorValue: '' }],
        environmentDetails: null,
        adGroup: 'Yes',
        privilegedADGroup: null,
        nonPrivilegedADGroup: null,
        businessAppService: 'No',
        businessApp: null,
        appService: null,
        isTouched: false,
        estimatedCost: null,
        appOwner: null,
        appOwnerDetails: null,
        certificateOwnerOne: null,
        certificateOwnerOneDetails: null,
        certificateOwnerTwo: null,
        certificateOwnerTwoDetails: null,
        businessContact: null,
        businessContactDetails: null,
        privilegedADGroupOwner: null,
        privilegedADGroupOwnerDetails: null,
        nonPrivilegedADGroupOwner: null,
        nonPrivilegedADGroupOwnerDetails: null,
        applicationName: null,
        appShortName: null,
        appSupportMailId: null,
    },
});

export const isGetAppShortNameLoading = atom({
    key: 'RI003-isGetAppShortNameLoading',
    default: false,
});

export const isAppNameValid = atom({
    key: 'RI003-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'RI003-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'RI003-isAppShortNameExist',
    default: false,
});

export const isBusinessNameValid = atom({
    key: 'RI003-isBusinessNameValid',
    default: true,
});

export const isBudgetCodeValid = atom({
    key: 'RI003-isBudgetCodeValid',
    default: true,
});

export const isBillingInfoValid = atom({
    key: 'RI003-isBillingInfoValid',
    default: true,
});

export const isProjectIdValid = atom({
    key: 'RI003-isProjectIdValid',
    default: false,
});

export const adGroupErrorMsg = atom({
    key: 'RI003-adGroupErrorMsg',
    default: false,
});

export const contributorErrorMsg = atom({
    key: 'RI003-contributorErrorMsg',
    default: false,
});

export const isADGroupValid = atom({
    key: 'RI003-isADGroupValid',
    default: true,
});

export const isBusinessAppValid = atom({
    key: 'RI003-isBusinessAppValid',
    default: false,
});

export const isAppUrlValid = atom({
    key: 'RI003-isAppUrlValid',
    default: false,
});

export const isAppContextPathValid = atom({
    key: 'RI003-isAppContextPathValid',
    default: false,
});

export const isNonPrivilegedADGroupValid = atom({
    key: 'RI003-isNonPrivilegedADGroupValid',
    default: false,
});

export const isPrivilegedADGroupValid = atom({
    key: 'RI003-isPrivilegedADGroupValid',
    default: false,
});

export const costEstimateState = atom({
    key: 'RI003-costEstimateState',
    default: null,
});

export const toggleModal = atom({
    key: 'RI003-toggleModal',
    default: {
        isADGroupModalOpen: false,
        isNonPrivilegedADGroupOpen: false,
        isPrivilegedADGroupOpen: false,
        isCost: { costType: '', isCostOpen: false },
    },
});

export const showPreviewOrder = atom({
    key: 'RI003-showPreviewOrder',
    default: false,
});

export const previewDetails = atom({
    key: 'RI003-previewdetails',
    default: null,
});
export const previewApiLoading = atom({
    key: 'RI003-previewApiLoading',
    default: false,
});
export const isSectorDisabled = atom({
    key: 'RI003-isSectorDisabled',
    default: true,
});
export const isBusinessUnitDisabled = atom({
    key: 'RI003-isBusinessUnitDisabled',
    default: true,
});
export const isHcodeDisabled = atom({
    key: 'RI003-isHcodeDisabled',
    default: true,
});
export const previewOrderError = atom({
    key: 'RI003-previewError',
    default: {
        isPreviewError: false,
        message: '',
    },
});

export const isValidappSupportMailId = atom({
    key: 'RI003-isValidappSupportMailId',
    default: false,
});

export const isValidOwners = atom({
    key: 'Ri003-isValidOwners',
    default: {
        isvalidAppOwner: true,
        isvalidCertificateOwnerOne: true,
        isvalidCertificateOwnerTwo: true,
    },
});

export const isValidISANumber = atom({
    key: 'RI003-isValidISANumber',
    default: false,
});
